<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <coupon-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CouponShowData from "./CouponShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CouponShow",
        components: {CrudShow, CouponShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'delivery.coupon.showing',
            }
        },
    }
</script>

